<template>
	<base-crud-page-update
			v-if="can('PERMISSION_UPDATE')"
			:title-name="titleName"
			:title-table="$tc('menu.permission', 1)"
			:back-url="{ name: 'mainPermissions' }"
	>
		<template #form>

			<the-form :model="model" edit @emit:submit="save"/>

		</template>
	</base-crud-page-update>
</template>

<script>
	import BaseCrudPageUpdate from '../../../../components/BaseCrudPageUpdate';
	import FormService from '../../../../services/FormService';
	import TheForm from '../components/TheForm';


	export default {
		name: 'PermissionsUpdate',
		components: {
			BaseCrudPageUpdate,
			TheForm,
		},
		props: {
			id: {
				type: [Number, String],
				default: 0,
			}
		},
		data()
		{
			return {
				model: new FormService({
					id: 0,
					name: '',
					codeName: '',
				}),
				titleName: '',
			};
		},
		mounted()
		{
			this.getOne();
		},
		methods: {
			getOne()
			{
				this.$api
					.get('permissions/' + this.id)
					.then(response => {
						this.model.SetData(response.data.data);
						this.titleName = response.data.data.name;
						this.$store.state.metaData.title = this.$route.meta.title(response.data.data.name);
					});
			},
			save()
			{
				this.model.codeName = this.model.name;

				this.$api
					.put('permissions', this.model.GetData())
					.then(response => {
						this.$router.push({ name: 'mainPermissions' });
					});
			}
		}
	};
</script>